class ShowReloadInfo
  constructor: (@container) ->
    info = @
    @div_info = $('#auto-reload-info')
    @checkbox = $('#auto_reload')
    this.showMessage(@checkbox)
    @checkbox.change ->
      info.showMessage($(this))

  showMessage: (checkbox) ->
    if checkbox.prop('checked')
      @div_info.show("slowly")
    else
      @div_info.hide("slowly")

$(document).ready ->
  $("*[data-behavior=ShowReloadInfo]").each ->
    new ShowReloadInfo($(@))
